import GenericDialog from "./generic";
import { deviceAdd } from "api/device";
import { DeviceAddBody } from "api/types/device";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import DeviceForm, { DeviceFormType } from "widgets/forms/devices/device";

const AddDeviceDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const { isOpen, onClose, onSuccess } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Function for linking an user
  const doLinkUser = async (formData: DeviceFormType) => {
    dispatch(setLoading(true));
    const newDevice: DeviceAddBody = {
      model: formData.model,
      snr: formData.snr,
      name: formData.name,
      commsType: formData.commsType,
    };

    if(formData.siteId) {
      newDevice.siteId = formData.siteId;
    }

    const { status } = await deviceAdd(newDevice);
    dispatch(setLoading(false));
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.device.add.success"), "success");
    } else {
      notifySimple(t("notification.device.add.error"), "error");
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      title={t("dialog.add.device.title")}
    >
      <DeviceForm
        submit={(data) => {
          doLinkUser(data);
        }}
        onClose={onClose}
      />
    </GenericDialog>
  );
};

export default AddDeviceDialog;
